import { useRouter } from 'next/navigation';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { useChat } from '@/providers/ChatProvider';
import { ChatType } from '@/types/chat';
import { getMessageTime } from '@/utils/helpers/getMessageTime';

import {
  ChannelAdName,
  ChannelAdPhoto,
  ChannelAvatar,
  ChannelDotDivider,
  ChannelInfo,
  ChannelItemContainer,
  ChannelMessageContainer,
  ChannelMessageContent,
  ChannelMessageTime,
  ChannelNewMessageIndicator
} from './styled';

interface Props {
  channel: ChatType;
  isSelected: boolean;
}

export const ChannelItem: React.FC<Props> = ({ channel, isSelected }) => {
  const router = useRouter();
  const { t } = useTranslation();
  const { selectedChannel } = useChat();
  const isCurrentChannelOpened = selectedChannel?.id === channel.id;

  const handleClick = () => {
    router.replace(`/conversation/${channel.id}`, {
      scroll: false
    });
  };

  return (
    <ChannelItemContainer onClick={handleClick} $isSelected={isSelected}>
      <ChannelAdPhoto $imageUrl={channel.listing?.photo || ''}>
        <ChannelAvatar
          $isSelected={isSelected}
          $imageUrl={
            channel?.receiver?.photo || channel.listing?.shop?.logo || ''
          }
        />
      </ChannelAdPhoto>
      <ChannelInfo>
        <ChannelAdName>{channel.listing?.name}</ChannelAdName>
        <ChannelMessageContainer>
          <ChannelMessageContent $isSelected={isSelected}>
            {channel.lastMessage?.text}
          </ChannelMessageContent>
          <ChannelDotDivider>•</ChannelDotDivider>
          <ChannelMessageTime>
            {channel.lastMessage?.createdAt &&
              getMessageTime(channel.lastMessage?.createdAt, t, true)}
          </ChannelMessageTime>
          {channel.unreadCount > 0 && !isCurrentChannelOpened && (
            <ChannelNewMessageIndicator />
          )}
        </ChannelMessageContainer>
      </ChannelInfo>
    </ChannelItemContainer>
  );
};
